// extracted by mini-css-extract-plugin
module.exports = {"image":"BadgeListItem_image__wfLVt"};